import { combineReducers } from 'redux';
import layoutReducer from './reducers/layoutReducer';

const rootReducer = combineReducers({
  layout: layoutReducer,
  // Otros reducers pueden ser agregados aquí
});

export default rootReducer;